import { render, staticRenderFns } from "./CommericalDashboard.vue?vue&type=template&id=6d11b296&scoped=true"
import script from "./CommericalDashboard.vue?vue&type=script&lang=js"
export * from "./CommericalDashboard.vue?vue&type=script&lang=js"
import style0 from "./CommericalDashboard.vue?vue&type=style&index=0&id=6d11b296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d11b296",
  null
  
)

export default component.exports